/** Nepali, keyed by the English text. Missing keys fall back to English. */
export const ne: Record<string, string> = {
  '8+ characters with upper and lower case, a number and a symbol.': 'ठूलो र सानो अक्षर, अंक र चिन्हसहित ८+ अक्षर।',
  'Account': 'खाता',
  'Active': 'सक्रिय',
  'Activity': 'गतिविधि',
  'Add': 'थप्नुहोस्',
  'Add a vehicle': 'गाडी थप्नुहोस्',
  'Add credit': 'रकम थप्नुहोस्',
  'Add your car to see how far a charge gets you.': 'एक चार्जले कति टाढा पुगिन्छ हेर्न आफ्नो गाडी थप्नुहोस्।',
  'Almost done': 'झन्डै सकियो',
  'Already have an account?': 'पहिल्यै खाता छ?',
  'An operator card only works at that operator’s stations and pays from your wallet with them.': 'सञ्चालकको कार्डले त्यही सञ्चालकका स्टेसनमा मात्र काम गर्छ र उहाँसँगको वालेटबाट तिर्छ।',
  'Appearance': 'रूप',
  'Back': 'पछाडि',
  'Back to sign in': 'साइन इनमा फर्कनुहोस्',
  'Back to the map': 'नक्सामा फर्कनुहोस्',
  'Balance': 'मौज्दात',
  'Battery': 'ब्याट्री',
  'Battery (kWh, optional)': 'ब्याट्री (kWh, ऐच्छिक)',
  'Blocked': 'रोकिएको',
  'Brand': 'ब्रान्ड',
  'By continuing you agree to the': 'अगाडि बढेर तपाईं सहमत हुनुहुन्छ',
  'CCS2': 'CCS2',
  'CCTV security': 'CCTV सुरक्षा',
  'CHAdeMO': 'CHAdeMO',
  'Call station': 'स्टेसनमा फोन गर्नुहोस्',
  'Cancel': 'रद्द गर्नुहोस्',
  'Card': 'कार्ड',
  'Change number': 'नम्बर बदल्नुहोस्',
  'Charge at any Saadhan Charge station. We text you a code to check your number.': 'जुनसुकै साधन चार्ज स्टेसनमा चार्ज गर्नुहोस्। नम्बर जाँच्न हामी तपाईंलाई कोड पठाउँछौं।',
  'Charger': 'चार्जर',
  'Charger {id} not found': 'चार्जर {id} भेटिएन',
  'Charger {id}, connector {n}': 'चार्जर {id}, कनेक्टर {n}',
  'Chargers': 'चार्जरहरू',
  'Charges': 'शुल्कहरू',
  'Charging': 'चार्ज हुँदै',
  'Charging at {station}': '{station} मा चार्ज हुँदै',
  'Charging finished': 'चार्ज सकियो',
  'Charging interrupted': 'चार्ज अवरुद्ध भयो',
  'Charging is paid from a wallet linked to an RFID card. Ask the staff at any station for a card and to add credit; it is linked to your phone number and works here straight away.': 'चार्जिङ RFID कार्डसँग जोडिएको वालेटबाट तिरिन्छ। जुनसुकै स्टेसनका कर्मचारीसँग कार्ड र रकम थप्न भन्नुहोस्; यो तपाईंको फोन नम्बरसँग जोडिन्छ र यहाँ तुरुन्तै चल्छ।',
  'Charging started': 'चार्ज सुरु भयो',
  'Charging, session #{id}': 'चार्जिङ, सत्र #{id}',
  'Check the ID on the charger, or find it on the map.': 'चार्जरमा ID जाँच्नुहोस्, वा नक्सामा खोज्नुहोस्।',
  'Choose': 'छान्नुहोस्',
  'Choose a password for signing in.': 'साइन इनका लागि पासवर्ड छान्नुहोस्।',
  'Close account': 'खाता बन्द गर्नुहोस्',
  'Close my account': 'मेरो खाता बन्द गर्नुहोस्',
  'Close your account?': 'खाता बन्द गर्ने?',
  'Closed': 'बन्द',
  'Closed now': 'अहिले बन्द',
  'Code': 'कोड',
  'Completed': 'सम्पन्न',
  'Connection to the charger lost': 'चार्जरसँगको जडान टुट्यो',
  'Connector not found': 'कनेक्टर भेटिएन',
  'Continue': 'अगाडि बढ्नुहोस्',
  'Couldn\'t load this': 'यो लोड हुन सकेन',
  'Create account': 'खाता बनाउनुहोस्',
  'Create an account': 'खाता बनाउनुहोस्',
  'Credit added': 'रकम थपियो',
  'Dark': 'गाढा',
  'Directions': 'बाटो',
  'Duration': 'अवधि',
  'Email (optional)': 'इमेल (ऐच्छिक)',
  'Ended': 'सकियो',
  'Energy': 'ऊर्जा',
  'Enter the code': 'कोड हाल्नुहोस्',
  'Expired': 'म्याद सकिएको',
  'Failed': 'असफल',
  'Fast (DC)': 'छिटो (DC)',
  'Find a charger': 'चार्जर खोज्नुहोस्',
  'Find a free charger on the map and press Start.': 'नक्सामा खाली चार्जर खोजेर सुरु थिच्नुहोस्।',
  'Finishing': 'सकिँदै',
  'Forgot your password?': 'पासवर्ड बिर्सनुभयो?',
  'Free': 'खाली',
  'Free now': 'अहिले खाली',
  'Friday': 'शुक्रबार',
  'Full name': 'पूरा नाम',
  'GB/T': 'GB/T',
  'Help and support': 'सहायता',
  'History': 'इतिहास',
  'Hotel': 'होटल',
  'In use': 'प्रयोगमा',
  'Inactive': 'निष्क्रिय',
  'Interrupted': 'अवरुद्ध',
  'Language': 'भाषा',
  'Light': 'उज्यालो',
  'Link copied': 'लिङ्क प्रतिलिपि भयो',
  'List': 'सूची',
  'Lost a card? Call the station that gave it to you so they can block it.': 'कार्ड हरायो? कार्ड दिने स्टेसनमा फोन गर्नुहोस् ताकि उहाँहरूले रोक्न सकून्।',
  'Lounge': 'लाउन्ज',
  'Low balance': 'कम मौज्दात',
  'Main vehicle': 'मुख्य गाडी',
  'Make main vehicle': 'मुख्य गाडी बनाउनुहोस्',
  'Map': 'नक्सा',
  'Member since {d}': '{d} देखि सदस्य',
  'Mobile number': 'मोबाइल नम्बर',
  'Model': 'मोडेल',
  'Monday': 'सोमबार',
  'Near me': 'मेरो नजिक',
  'Needs {list}.': '{list} चाहिन्छ।',
  'Nepal numbers only for now.': 'अहिलेलाई नेपाली नम्बर मात्र।',
  'New here?': 'नयाँ हुनुहुन्छ?',
  'Next page': 'अर्को पेज',
  'No activity yet': 'अहिलेसम्म गतिविधि छैन',
  'No card yet. Ask the staff at a station for one; you need it to charge.': 'अहिलेसम्म कार्ड छैन। स्टेसनका कर्मचारीसँग माग्नुहोस्; चार्ज गर्न चाहिन्छ।',
  'No charges yet': 'अहिलेसम्म शुल्क छैन',
  'No stations match': 'मिल्ने स्टेसन छैन',
  'No wallet yet. It opens when an operator adds credit for you.': 'अहिलेसम्म वालेट छैन। सञ्चालकले तपाईंका लागि रकम थपेपछि खुल्छ।',
  'None free': 'कुनै खाली छैन',
  'Not charging': 'चार्ज भइरहेको छैन',
  'Offline': 'अफलाइन',
  'Open 24 hours': '२४ घण्टा खुला',
  'Open 24 hours, every day': 'हरेक दिन २४ घण्टा खुला',
  'Open now': 'अहिले खुला',
  'Open the map': 'नक्सा खोल्नुहोस्',
  'Opening hours': 'खुल्ने समय',
  'Operator card': 'सञ्चालकको कार्ड',
  'Out of order': 'बिग्रिएको',
  'Page not found': 'पृष्ठ भेटिएन',
  'Page {page} of {total}': 'पेज {page} / {total}',
  'Park and plug the cable into your car.': 'गाडी पार्क गरेर केबल गाडीमा जोड्नुहोस्।',
  'Parking': 'पार्किङ',
  'Password': 'पासवर्ड',
  'Pay at the counter of any station. The staff add it to your wallet with that operator straight away.': 'जुनसुकै स्टेसनको काउन्टरमा तिर्नुहोस्। कर्मचारीले त्यो सञ्चालकसँगको तपाईंको वालेटमा तुरुन्तै थप्छन्।',
  'Pay with': 'यसबाट तिर्ने',
  'Paying online with eSewa, Khalti or Fonepay is coming soon.': 'eSewa, Khalti वा Fonepay बाट अनलाइन भुक्तानी छिट्टै आउँदैछ।',
  'Phone notifications': 'फोन सूचना',
  'Phone or email': 'फोन वा इमेल',
  'Plugged in': 'प्लग गरिएको',
  'Power': 'पावर',
  'Press Start. The charger begins within a few seconds.': 'सुरु थिच्नुहोस्। केही सेकेन्डमै चार्जर सुरु हुन्छ।',
  'Previous page': 'अघिल्लो पेज',
  'Price plan': 'मूल्य योजना',
  'Privacy policy': 'गोपनीयता नीति',
  'Rate': 'दर',
  'Receipt': 'रसिद',
  'Refund': 'फिर्ता',
  'Remove': 'हटाउनुहोस्',
  'Reserved': 'आरक्षित',
  'Resetting a password by SMS is coming soon. Until then, write to us and we will help you get back in.': 'SMS बाट पासवर्ड रिसेट छिट्टै आउँदैछ। त्यतिन्जेल हामीलाई लेख्नुहोस्, हामी फेरि भित्र पस्न मद्दत गर्छौं।',
  'Restaurant / cafe': 'रेस्टुरेन्ट / क्याफे',
  'Restroom': 'शौचालय',
  'Saadhan super card': 'साधन सुपर कार्ड',
  'Saadhan super card · works at every station': 'साधन सुपर कार्ड · सबै स्टेसनमा चल्छ',
  'Saadhan wallet (super card)': 'साधन वालेट (सुपर कार्ड)',
  'Saturday': 'शनिबार',
  'Save': 'सेभ गर्नुहोस्',
  'Saved': 'सुरक्षित भयो',
  'Search stations or places': 'स्टेसन वा ठाउँ खोज्नुहोस्',
  'See your wallet': 'वालेट हेर्नुहोस्',
  'Send again': 'फेरि पठाउनुहोस्',
  'Send code': 'कोड पठाउनुहोस्',
  'Sent to the Saadhan Charge app if you also have it installed.': 'साधन चार्ज एप पनि जडान गर्नुभएको छ भने त्यसमा पठाइन्छ।',
  'Session #{id}': 'सत्र #{id}',
  'Share': 'साझा गर्नुहोस्',
  'Shop': 'पसल',
  'Show more': 'थप देखाउनुहोस्',
  'Sign in': 'साइन इन',
  'Sign out': 'बाहिर निस्कनुहोस्',
  'Snacks': 'खाजा',
  'Spent': 'खर्च',
  'Start': 'सुरु',
  'Start charging': 'चार्ज सुरु गर्नुहोस्',
  'Started': 'सुरु',
  'Started {at}': '{at} मा सुरु',
  'Station': 'स्टेसन',
  'Station not found': 'स्टेसन भेटिएन',
  'Stop charging': 'चार्ज रोक्नुहोस्',
  'Stop charging before closing your account': 'खाता बन्द गर्नुअघि चार्ज रोक्नुहोस्',
  'Stop charging?': 'चार्ज रोक्ने?',
  'Stop sent. The charger finishes in a few seconds.': 'रोक्ने आदेश पठाइयो। केही सेकेन्डमा चार्जर सकिन्छ।',
  'Stopped': 'रोकिएको',
  'Sunday': 'आइतबार',
  'System': 'प्रणाली',
  'Terms of use': 'प्रयोगका सर्त',
  'The charger reports energy about every 30 seconds; this page updates every 5.': 'चार्जरले करिब हरेक ३० सेकेन्डमा ऊर्जा जनाउँछ; यो पृष्ठ हरेक ५ सेकेन्डमा अद्यावधिक हुन्छ।',
  'This connector cannot start a charge right now. Pick another one at the station.': 'यो कनेक्टरबाट अहिले चार्ज सुरु गर्न सकिँदैन। स्टेसनमा अर्को छान्नुहोस्।',
  'Thursday': 'बिहीबार',
  'Time': 'समय',
  'Time-of-day rate': 'समय अनुसारको दर',
  'Try again': 'फेरि प्रयास गर्नुहोस्',
  'Tuesday': 'मङ्गलबार',
  'Type 2': 'Type 2',
  'Unavailable': 'अनुपलब्ध',
  'Use the same account as the Saadhan Charge app.': 'साधन चार्ज एपकै खाता प्रयोग गर्नुहोस्।',
  'Vehicle added': 'गाडी थपियो',
  'Vehicle removed': 'गाडी हटाइयो',
  'Waiting for the charger': 'चार्जर पर्खँदै',
  'Wallet': 'वालेट',
  'We sent a 6-digit code to {phone}.': 'हामीले {phone} मा ६ अंकको कोड पठायौं।',
  'Wednesday': 'बुधबार',
  'While you charge': 'चार्ज हुँदासम्म',
  'Wi-Fi': 'Wi-Fi',
  'You are signed out everywhere and can no longer charge with your cards. Any wallet balance stays with the operators; contact them about it first.': 'तपाईं सबैतिरबाट साइन आउट हुनुहुन्छ र आफ्ना कार्डबाट चार्ज गर्न सक्नुहुन्न। वालेटको मौज्दात सञ्चालकसँगै रहन्छ; पहिले उहाँहरूसँग सम्पर्क गर्नुहोस्।',
  'You need a charging card first': 'पहिले चार्जिङ कार्ड चाहिन्छ',
  'You pay for the energy used so far. Unplug the cable after the charger finishes.': 'अहिलेसम्म प्रयोग भएको ऊर्जाको मात्र तिर्नुहुन्छ। चार्जर सकिएपछि केबल निकाल्नुहोस्।',
  'You pay for the energy used. Stop any time from this site.': 'प्रयोग भएको ऊर्जाको मात्र तिर्नुहुन्छ। यो साइटबाट जुनसुकै बेला रोक्न सक्नुहुन्छ।',
  'Your account': 'तपाईंको खाता',
  'Your balance with each operator, and with Saadhan for a super card.': 'हरेक सञ्चालकसँग, र सुपर कार्डका लागि साधनसँगको तपाईंको मौज्दात।',
  'Your cards': 'तपाईंका कार्ड',
  'Your charges and receipts appear here.': 'तपाईंका चार्ज र रसिद यहाँ देखिन्छन्।',
  'Your details': 'तपाईंको विवरण',
  'Your last charge': 'तपाईंको अन्तिम चार्ज',
  'Your name': 'तपाईंको नाम',
  'Your phone number signs you in and cannot be changed here.': 'तपाईंको फोन नम्बरबाट साइन इन हुन्छ र यहाँ बदल्न मिल्दैन।',
  'Your vehicles': 'तपाईंका गाडी',
  'a number': 'अंक',
  'a symbol': 'चिन्ह',
  'and': 'र',
  'at least 8 characters': 'कम्तीमा ८ अक्षर',
  'expires {d}': '{d} मा म्याद सकिन्छ',
  'privacy policy': 'गोपनीयता नीति',
  'terms': 'सर्तहरू',
  'up to {kw}': '{kw} सम्म',
  'upper and lower case letters': 'ठूलो र सानो अक्षर',
  '{id} accepted the request. Charging shows here as soon as it begins. Make sure the cable is plugged into your car.': '{id} ले अनुरोध स्वीकार्‍यो। चार्ज सुरु हुनेबित्तिकै यहाँ देखिन्छ। केबल गाडीमा जोडिएको छ भनी निश्चित गर्नुहोस्।',
  '{n} free': '{n} खाली',
  '{n} results': '{n} नतिजा',
  'About': 'विषय',
  'Add photo': 'तस्बिर थप्नुहोस्',
  'Add to favourites': 'मनपर्नेमा थप्नुहोस्',
  'Add your car in Account to fill this in.': 'यो भर्न खातामा आफ्नो गाडी थप्नुहोस्।',
  'After about {km} km the battery would fall below 15% with no station on the way. Start with more charge or plan a longer stop.': 'करिब {km} km पछि ब्याट्री १५% भन्दा तल झर्छ र बाटोमा स्टेसन छैन। धेरै चार्ज गरेर हिँड्नुहोस् वा लामो विश्राम योजना बनाउनुहोस्।',
  'All busy? Get told when one frees up': 'सबै व्यस्त? खाली हुनेबित्तिकै थाहा पाउनुहोस्',
  'An operator card works at that operator’s stations. A Saadhan super card works at every station on Saadhan Charge.': 'सञ्चालकको कार्ड त्यो सञ्चालकका स्टेसनमा चल्छ। साधन सुपर कार्ड साधन चार्जका सबै स्टेसनमा चल्छ।',
  'Answers to common questions, and a way to reach the station team.': 'सामान्य प्रश्नका उत्तर, र स्टेसन टोलीसम्म पुग्ने उपाय।',
  'Any connector': 'कुनै पनि कनेक्टर',
  'Arrive with about {p}%': 'करिब {p}% सहित पुग्नुहुन्छ',
  'At {km} km': '{km} km मा',
  'At {km} km · arrive with about {a}% · charge to {b}%, roughly {m}': '{km} km मा · करिब {a}% सहित पुग्ने · {b}% सम्म चार्ज, करिब {m}',
  'Battery size (kWh)': 'ब्याट्री क्षमता (kWh)',
  'Bay blocked by another car': 'अर्को गाडीले ठाउँ ओगटेको',
  'Cable or connector damaged': 'केबल वा कनेक्टर बिग्रिएको',
  'Call the station': 'स्टेसनमा फोन गर्नुहोस्',
  'Call the station from its page on the map, or write to us.': 'नक्साको स्टेसन पृष्ठबाट फोन गर्नुहोस्, वा हामीलाई लेख्नुहोस्।',
  'Can I use one card at every station?': 'एउटै कार्ड सबै स्टेसनमा चल्छ?',
  'Charge first at {station}, near the start': 'सुरुमै {station} मा चार्ज गर्नुहोस्',
  'Charge now (%)': 'अहिलेको चार्ज (%)',
  'Charging stops': 'चार्जिङ बिसौनी',
  'Check the cable is fully in and the car is unlocked, then try again. If it still fails, use Report a problem on the station page so the team can check the charger.': 'केबल पूरै छिरेको र गाडी अनलक भएको जाँचेर फेरि प्रयास गर्नुहोस्। अझै भएन भने स्टेसन पृष्ठमा समस्या रिपोर्ट गर्नुहोस् ताकि टोलीले चार्जर जाँचोस्।',
  'Common questions': 'सामान्य प्रश्न',
  'Connector': 'कनेक्टर',
  'Connector type': 'कनेक्टरको प्रकार',
  'Could not get your location. Choose a town instead.': 'तपाईंको स्थान पाउन सकिएन। बरु सहर छान्नुहोस्।',
  'Date': 'मिति',
  'Details (optional)': 'विवरण (ऐच्छिक)',
  'Distance': 'दूरी',
  'Driving': 'ड्राइभिङ',
  'Email Saadhan Charge': 'साधन चार्जलाई इमेल गर्नुहोस्',
  'Email me': 'मलाई इमेल गर्नुहोस्',
  'Emailing receipts is coming soon. Use Print to save a PDF.': 'रसिद इमेल छिट्टै आउँदैछ। PDF सुरक्षित गर्न प्रिन्ट प्रयोग गर्नुहोस्।',
  'Error code, what you tried…': 'त्रुटि कोड, के गर्नुभयो…',
  'Error on the screen': 'स्क्रिनमा त्रुटि',
  'Estimates only: hills, speed, AC and weather change your range. Routes from OpenStreetMap.': 'अनुमान मात्र: उकालो, गति, AC र मौसमले दूरी फरक पार्छ। बाटो OpenStreetMap बाट।',
  'Every charge is paid from a wallet linked to an RFID card. Ask the staff at any station for a card; it is linked to your phone number.': 'हरेक चार्ज RFID कार्डसँग जोडिएको वालेटबाट तिरिन्छ। जुनसुकै स्टेसनका कर्मचारीसँग कार्ड माग्नुहोस्; यो तपाईंको फोन नम्बरसँग जोडिन्छ।',
  'Find a free connector on the map, open the station, press Start, choose the card to pay with and plug in. You can stop from the Charging tab.': 'नक्सामा खाली कनेक्टर खोज्नुहोस्, स्टेसन खोल्नुहोस्, सुरु थिच्नुहोस्, तिर्ने कार्ड छान्नुहोस् र जोड्नुहोस्। चार्जिङ ट्याबबाट रोक्न सक्नुहुन्छ।',
  'From': 'देखि',
  'From your {car}': 'तपाईंको {car} बाट',
  'Help': 'सहायता',
  'Hills use more': 'उकालोमा बढी खर्च हुन्छ',
  'How do I add credit?': 'रकम कसरी थप्ने?',
  'How do I start charging?': 'चार्ज कसरी सुरु गर्ने?',
  'I was charged the wrong amount': 'मबाट गलत रकम काटियो',
  'Leave with {p}%': '{p}% सहित हिँड्नुहोस्',
  'Message': 'सन्देश',
  'Message not found': 'सन्देश भेटिएन',
  'Message sent. You will see the reply here.': 'सन्देश पठाइयो। जवाफ यहीँ देखिन्छ।',
  'Messages are coming soon. Please email summit@saadhan.app.': 'सन्देश सुविधा छिट्टै आउँदैछ। कृपया summit@saadhan.app मा इमेल गर्नुहोस्।',
  'My account': 'मेरो खाता',
  'My location': 'मेरो स्थान',
  'Near the destination': 'गन्तव्य नजिक',
  'Near the start': 'सुरुवात नजिक',
  'New message': 'नयाँ सन्देश',
  'No charger in reach': 'पुग्ने दूरीमा चार्जर छैन',
  'No messages yet.': 'अहिलेसम्म सन्देश छैन।',
  'No reviews yet. Charged here? Tell other drivers how it went.': 'अहिलेसम्म समीक्षा छैन। यहाँ चार्ज गर्नुभयो? अरू चालकलाई कस्तो रह्यो भन्नुहोस्।',
  'None free now': 'अहिले कुनै खाली छैन',
  'Not about a charge': 'चार्जसँग सम्बन्धित होइन',
  'Not sure': 'थाहा छैन',
  'Notify me': 'मलाई जानकारी दिनुहोस्',
  'Older receipts are in History.': 'पुराना रसिद इतिहासमा छन्।',
  'Open receipt': 'रसिद खोल्नुहोस्',
  'Open the receipt in History, then send us a message below with the receipt number. Refunds go back to the wallet that paid.': 'इतिहासमा रसिद खोल्नुहोस्, अनि रसिद नम्बरसहित तल सन्देश पठाउनुहोस्। फिर्ता रकम तिरेको वालेटमै जान्छ।',
  'Operator': 'सञ्चालक',
  'Other stations on the way': 'बाटोमा अरू स्टेसन',
  'Paid with card': 'तिरेको कार्ड',
  'Pay at the counter of any station and the staff add it to your wallet with that operator. Online payment with eSewa, Khalti and Fonepay is coming soon.': 'जुनसुकै स्टेसनको काउन्टरमा तिर्नुहोस्, कर्मचारीले त्यो सञ्चालकसँगको वालेटमा थप्छन्। eSewa, Khalti र Fonepay बाट अनलाइन भुक्तानी छिट्टै आउँदैछ।',
  'Payment or refund': 'भुक्तानी वा फिर्ता',
  'Photo by a driver': 'चालकले खिचेको तस्बिर',
  'Photos (optional)': 'तस्बिर (ऐच्छिक)',
  'Photos help other drivers find the chargers. Please leave out people and number plates.': 'तस्बिरले अरू चालकलाई चार्जर भेट्टाउन मद्दत गर्छ। कृपया मानिस र नम्बर प्लेट नराख्नुहोस्।',
  'Photos of the station (optional)': 'स्टेसनका तस्बिर (ऐच्छिक)',
  'Plan a trip': 'यात्रा योजना',
  'Plan route': 'बाटो योजना बनाउनुहोस्',
  'Post review': 'समीक्षा पोस्ट गर्नुहोस्',
  'Print / PDF': 'प्रिन्ट / PDF',
  'Problem at a charger': 'चार्जरमा समस्या',
  'Questions about this charge? Write to us from Help with the receipt number.': 'यो चार्जबारे प्रश्न छ? रसिद नम्बरसहित सहायताबाट लेख्नुहोस्।',
  'Range about {km} km on a full battery.': 'पूरा ब्याट्रीमा करिब {km} km।',
  'Rate this station': 'यो स्टेसनको मूल्याङ्कन गर्नुहोस्',
  'Rate {station}': '{station} को मूल्याङ्कन',
  'Rating': 'मूल्याङ्कन',
  'Receipt #{id}': 'रसिद #{id}',
  'Receipt not found': 'रसिद भेटिएन',
  'Remove from favourites': 'मनपर्नेबाट हटाउनुहोस्',
  'Remove photo': 'तस्बिर हटाउनुहोस्',
  'Removed from favourites': 'मनपर्नेबाट हटाइयो',
  'Replied': 'जवाफ आयो',
  'Reply': 'जवाफ',
  'Reply from the station': 'स्टेसनको जवाफ',
  'Report a problem': 'समस्या रिपोर्ट गर्नुहोस्',
  'Reports from the website are not switched on yet. Please tell the station directly:': 'वेबसाइटबाट रिपोर्ट अझै सुरु भएको छैन। कृपया स्टेसनलाई सिधै भन्नुहोस्:',
  'Resolved': 'समाधान भयो',
  'Reviews': 'समीक्षाहरू',
  'Reviews are coming soon.': 'समीक्षा छिट्टै आउँदैछ।',
  'Saved to favourites': 'मनपर्नेमा सुरक्षित भयो',
  'Send': 'पठाउनुहोस्',
  'Send report': 'रिपोर्ट पठाउनुहोस्',
  'Sent': 'पठाइयो',
  'Sent to {email}': '{email} मा पठाइयो',
  'Something else': 'अरू केही',
  'Speed, waiting time, toilets, food nearby…': 'गति, पर्खाइ, शौचालय, नजिकै खाना…',
  'Station team': 'स्टेसन टोली',
  'Still charging; the total will change.': 'अझै चार्ज हुँदै; जम्मा रकम बदलिन्छ।',
  'Still need help?': 'अझै सहायता चाहिन्छ?',
  'Stop': 'रोक्नुहोस्',
  'Stopped early': 'चाँडै रोकियो',
  'Subject': 'विषय',
  'Thanks for your review': 'समीक्षाका लागि धन्यवाद',
  'Thanks. The station team has your report and will reply in Help.': 'धन्यवाद। स्टेसन टोलीले तपाईंको रिपोर्ट पायो र सहायतामा जवाफ दिनेछ।',
  'The charger did not start': 'चार्जर सुरु भएन',
  'This charge ended early: {reason}': 'यो चार्ज चाँडै सकियो: {reason}',
  'To': 'सम्म',
  'Total paid': 'जम्मा तिरेको',
  'Charging cost': 'चार्जिङ शुल्क',
  'Amount collected': 'असुल गरिएको रकम',
  'Outstanding amount: {amount}': 'बाँकी रकम: {amount}',
  'Until {time}. Keep this site open in a tab, with notifications allowed.': '{time} सम्म। सूचना अनुमति दिएर यो साइट ट्याबमा खुला राख्नुहोस्।',
  'Use my location': 'मेरो स्थान प्रयोग गर्नुहोस्',
  'Watching {station}': '{station} हेर्दै',
  'We will tell you when {type} is free': '{type} खाली हुँदा हामी जानकारी दिनेछौं',
  'What is wrong?': 'के समस्या छ?',
  'Where to charge on the way, for your car’s range.': 'तपाईंको गाडीको दूरीअनुसार बाटोमा कहाँ चार्ज गर्ने।',
  'Which charge? (optional)': 'कुन चार्ज? (ऐच्छिक)',
  'Why do I need a card?': 'कार्ड किन चाहिन्छ?',
  'Will not start': 'सुरु हुँदैन',
  'Write a reply': 'जवाफ लेख्नुहोस्',
  'Write a review': 'समीक्षा लेख्नुहोस्',
  'Wrong price or charge': 'गलत मूल्य वा शुल्क',
  'You': 'तपाईं',
  'Your messages': 'तपाईंका सन्देश',
  'Your review (optional)': 'तपाईंको समीक्षा (ऐच्छिक)',
  'Your trip': 'तपाईंको यात्रा',
  'a connector': 'एउटा कनेक्टर',
  'connector {n}': 'कनेक्टर {n}',
  'km per kWh': 'प्रति kWh km',
  'to send a report and get a reply, or contact the station now:': 'रिपोर्ट पठाएर जवाफ पाउन, वा अहिले नै स्टेसनसँग सम्पर्क गर्नुहोस्:',
  '{km} km off the road': 'सडकबाट {km} km टाढा',
  '{n} free now': 'अहिले {n} खाली',
  '{n} reviews': '{n} समीक्षा',
  '♥ Favourites': '♥ मनपर्ने',
  // Page failed to load
  "Something went wrong": "केही गडबड भयो",
  "Reload the page. If it keeps happening, tell us what you were doing.": "पेज रिलोड गर्नुहोस्। बारम्बार भइरहे के गर्दै हुनुहुन्थ्यो हामीलाई भन्नुहोस्।",
  "Reload": "रिलोड",
  "Go to the map": "नक्सामा जानुहोस्",
  "Top up online": "अनलाइन रिचार्ज",
  "Pay from your bank with Nepal Payment Solutions. It goes to your Saadhan wallet, which your super card charges from.": "नेपाल पेमेन्ट सोलुसनमार्फत आफ्नो बैंकबाट तिर्नुहोस्। रकम तपाईंको साधन वालेटमा जान्छ, जसबाट तपाईंको सुपर कार्डले चार्ज गर्छ।",
  "You don't have a super card yet. You need one to charge from this wallet; ask the staff at any station.": "तपाईंसँग अझै सुपर कार्ड छैन। यो वालेटबाट चार्ज गर्न सुपर कार्ड चाहिन्छ; जुनसुकै स्टेसनका कर्मचारीलाई सोध्नुहोस्।",
  "Amount (Rs)": "रकम (रु)",
  "From {min} to {max}": "{min} देखि {max} सम्म",
  "Top up between {min} and {max}.": "{min} देखि {max} सम्म रिचार्ज गर्नुहोस्।",
  "Top up in whole rupees.": "पूरा रुपैयाँमा रिचार्ज गर्नुहोस्।",
  "Choose on the payment page": "भुक्तानी पेजमा छान्नुहोस्",
  "Mobile banking": "मोबाइल बैंकिङ",
  "Internet banking": "इन्टरनेट बैंकिङ",
  "Cards": "कार्ड",
  "Wallets": "वालेट",
  "Other": "अन्य",
  "Added to your wallet": "वालेटमा थपिने",
  "Bank service charge": "बैंक सेवा शुल्क",
  "You pay": "तपाईंले तिर्ने",
  "The bank adds a small service charge on top. You see it before you pay.": "बैंकले थोरै सेवा शुल्क थप्छ। तिर्नुअघि तपाईंले देख्नुहुन्छ।",
  "Top up {amount}": "{amount} रिचार्ज गर्नुहोस्",
  "Top up": "रिचार्ज",
  "We couldn't find that payment": "त्यो भुक्तानी भेटिएन",
  "Check your wallet for the latest balance.": "पछिल्लो ब्यालेन्स वालेटमा हेर्नुहोस्।",
  "Go to wallet": "वालेटमा जानुहोस्",
  "You can close this page and go back to the Saadhan Charge app.": "यो पेज बन्द गरेर साधन चार्ज एपमा फर्कन सक्नुहुन्छ।",
  "Reference {ref}": "सन्दर्भ नम्बर {ref}",
  "{amount} added to your wallet": "वालेटमा {amount} थपियो",
  "You paid {total} including the bank service charge.": "बैंक सेवा शुल्कसहित तपाईंले {total} तिर्नुभयो।",
  "The payment didn’t go through": "भुक्तानी सफल भएन",
  "Nothing was added to your wallet. If money left your bank account, contact us with the reference below.": "वालेटमा केही थपिएन। बैंक खाताबाट पैसा कटेको भए तलको सन्दर्भ नम्बरसहित हामीलाई सम्पर्क गर्नुहोस्।",
  "We couldn’t confirm this payment": "यो भुक्तानी पुष्टि गर्न सकिएन",
  "If money left your bank account, contact us with the reference below and we’ll sort it out.": "बैंक खाताबाट पैसा कटेको भए तलको सन्दर्भ नम्बरसहित हामीलाई सम्पर्क गर्नुहोस्, हामी मिलाउँछौँ।",
  "Waiting for your bank to confirm": "बैंकको पुष्टिको पर्खाइमा",
  "Your wallet is credited as soon as the bank confirms. This can take a few minutes.": "बैंकले पुष्टि गर्नेबित्तिकै वालेटमा रकम थपिन्छ। केही मिनेट लाग्न सक्छ।",
  "This page updates by itself.": "यो पेज आफैँ अपडेट हुन्छ।",
}
